import React from 'react';
import Icon from '../../../components/AppIcon';

const AgentBenefits = () => {
  const benefits = [
    {
      icon: 'DollarSign',
      title: 'Commissie Tracking',
      description: 'Real-time inzicht in uw verdiensten',
      color: 'var(--color-success)',
    },
    {
      icon: 'Users',
      title: 'Lead Management',
      description: 'Beheer al uw prospects efficiënt',
      color: 'var(--color-primary)',
    },
    {
      icon: 'BarChart3',
      title: 'Prestatie Analytics',
      description: 'Gedetailleerde rapportages en insights',
      color: 'var(--color-secondary)',
    },
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
        Uw Sales Tools
      </h3>
      <div className="space-y-4">
        {benefits?.map((benefit, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name={benefit?.icon} size={20} color={benefit?.color} />
            </div>
            <div>
              <h4 className="text-sm font-heading font-medium text-foreground mb-1">
                {benefit?.title}
              </h4>
              <p className="text-sm font-body text-muted-foreground">
                {benefit?.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-primary/5 rounded-lg border border-primary/20">
        <div className="flex items-center space-x-2 mb-2">
          <Icon name="Award" size={20} color="var(--color-primary)" />
          <span className="text-sm font-heading font-semibold text-foreground">
            Top Performer Programma
          </span>
        </div>
        <p className="text-sm font-body text-muted-foreground">
          Verdien extra bonussen en erkenning als top sales agent
        </p>
      </div>
    </div>
  );
};

export default AgentBenefits;